import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
// import * as Sentry from "@sentry/react"
// import { Integrations } from "@sentry/tracing";
// import { SENTRY_DSN } from "./configs/api"
// import { Dedupe as DedupeIntegration } from "@sentry/integrations";

// process.env.NODE_ENV === "production" &&
// Sentry.init({
//   dsn: SENTRY_DSN,
//   autoSessionTracking: true,
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 0.01,
//   maxBreadcrumbs: 50,
//   debug: true,
// })

const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
